import * as React from "react";
const SvgGitlab = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E24329",
  d: "m22.8 9.416-.03-.079-3.005-7.84a.793.793 0 0 0-1.5.081l-2.03 6.21H8.027l-2.03-6.21a.79.79 0 0 0-1.19-.454.78.78 0 0 0-.31.373l-3.005 7.84-.03.08a5.58 5.58 0 0 0 1.851 6.447l.011.008.027.02 4.577 3.427 2.264 1.714 1.378 1.042a.93.93 0 0 0 1.122 0l1.378-1.042 2.264-1.714 4.604-3.447.012-.009a5.58 5.58 0 0 0 1.85-6.447"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC6D26",
  d: "m22.8 9.416-.03-.079c-1.491.306-2.864.937-4.04 1.817l-6.599 4.99 4.203 3.175 4.604-3.447.012-.009a5.58 5.58 0 0 0 1.85-6.447"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCA326",
  d: "m7.928 19.32 2.264 1.713 1.378 1.042a.93.93 0 0 0 1.122 0l1.378-1.042 2.264-1.714-4.203-3.176c-2.247 1.7-4.203 3.176-4.203 3.176"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC6D26",
  d: "M5.532 11.154a10.1 10.1 0 0 0-4.04-1.816l-.03.078a5.58 5.58 0 0 0 1.851 6.448l.011.008.027.02 4.577 3.427 4.203-3.176z"
}));
export default SvgGitlab;
//# sourceMappingURL=Gitlab.js.map